/**
 * Convert date string into decimal number
 *
 * @example
 *
 * '2020-09-19' => 2020.7168715846994
 */
export const toDecimalYear = (dateStr: string): number => {
  const date = new Date(dateStr)
  const year = date.getFullYear()

  const startOfYear = new Date(year, 0, 1)
  const endOfYear = new Date(year + 1, 0, 1)

  const daysElapsed = (date.getTime() - startOfYear.getTime()) / (1000 * 60 * 60 * 24)
  const totalDaysInYear = (endOfYear.getTime() - startOfYear.getTime()) / (1000 * 60 * 60 * 24)

  const decimalYear = year + daysElapsed / totalDaysInYear

  return decimalYear
}
